import React, { useState, useEffect } from "react";
import Leftbar from "../../components/Leftsidebar";
import Topbar from "../../components/Topbar";
import { Link } from "react-router-dom";
import "../Projects/project.css";
import { exportNewMatched, handleFundsecurelist, MarkAsCompleted, newMatchesApi, showToast, usTimezone } from '../Utils/utils';
import ReactPaginate from 'react-paginate';
import { Col, Row, Button } from 'react-bootstrap';
import Loaderspinner from "../../components/Loader";
import { toast } from "react-toastify";
import ConfirmationModal from "../../components/Modal/ConfirmationModal";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment-timezone';
import { Tooltip } from 'react-tooltip'

const NewMatches = () => {
  const [showSidebar, setShowSidebar] = useState(false);
  const [fundSecureList, setFundsecureList] = useState([]);
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);
  const [projectId, setProjectId] = useState('');
  let isMarked = localStorage.getItem('role')
  const [typeStatus, setTypeStatus] = useState("");
  const [startDate, setStartDate] = useState(moment().subtract(1, 'months').toDate());
  const [endDate, setEndDate] = useState(new Date());

  const handleSidebar = () => {
    setShowSidebar(!showSidebar);
  };

  const handleSidebarClose = () => {
    setShowSidebar(false);
  };

  useEffect(() => {
    const fetchFundSecurelist = async () => {
      try {
        setLoading(true)
        const token = localStorage.getItem("token");
        const limit = 10;
        const offset = page * limit;
        const req = {
          limit: limit,
          offset: offset,
          status: typeStatus,
          from: startDate != "" ? `${moment(startDate).tz('America/New_York').format('YYYY-MM-DD')} 00:00:00` : '',
          to: endDate != "" ? `${moment(endDate).tz('America/New_York').format('YYYY-MM-DD')} 23:59:59` : ''
        }
        const response = await newMatchesApi(req);

        setFundsecureList(response?.data || []);

        if ((response?.data?.length || 0) < limit) {
          setTotalPages(page + 1);
        } else {
          setTotalPages(page + 2);
        }

      } catch (error) {
        console.error("Error fetching lenders:", error);
      } finally {
        setLoading(false)
      }
    };

    fetchFundSecurelist();
  }, [page, startDate, endDate, typeStatus]);

  const MarkCompleted = async (id) => {
    try {
      setLoading(true);
      setShow(false);
      const response = await MarkAsCompleted(id);
      toast.success(response?.message)
    } catch (error) {
      toast.error(error?.message)
      console.error("Error fetching lenders:", error);
    } finally {
      setLoading(false)
    }
  };


  const exportList = async () => {
    try {
      setLoading(true);
      const req = {
        status: typeStatus,
        from: startDate != "" ? `${moment(startDate).tz('America/New_York').format('YYYY-MM-DD')} 00:00:00` : '',
        to: endDate != "" ? `${moment(endDate).tz('America/New_York').format('YYYY-MM-DD')} 23:59:59` : ''
      }
      const blobData = await exportNewMatched(req);
      console.log(blobData, "blobData.......")
      if (blobData.size === 6506) {
        showToast("No data available for export.", "error");
        return;
      }

      const blob = new Blob([blobData], { type: "text/csv" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "new_matches_list.csv");
      document.body.appendChild(link);

      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Export failed:", error);
      showToast(error.message, "error")
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading && <Loaderspinner />}
      <div className="g-sidenav-show bg-gray-100">
        <div id="wrapper">
          <Leftbar showSidebar={showSidebar}
            handleSidebarClose={handleSidebarClose} />
          <main className="main-content border-radius-lg">
            <Topbar handleSidebar={handleSidebar} />

            <div className="header header-bg pb-6">
              <div className="container-fluid">
                <div className="header-body">
                  <div className="row align-items-center py-4">
                    <div className="col-lg-6 col-7">
                      <nav
                        aria-label="breadcrumb"
                        className="d-none d-md-inline-block ml-md-4"
                      >
                        <ol className="breadcrumb breadcrumb-links breadcrumb-dark" style={{ background: "transparent" }}>
                          <li className="breadcrumb-item">
                            <Link to="/dashboard">
                              <i className="fas fa-home" />
                            </Link>
                          </li>
                          <li className="breadcrumb-item mt-2">
                            <span className="" style={{ color: "#f6f9fc" }}>New Matches Created</span>
                          </li>
                        </ol>
                      </nav>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="container-fluid mt--6">
              <div className="row">
                <div className="col">
                  <div className="card">
                    <div className="card-header border-0">
                      <div className="d-flex justify-content-between">
                        <div className="row">
                          <h5 className="mb-0 w-auto">New Matches Created </h5>
                          <p
                            className="w-auto px-0"
                            style={{ zIndex: 99 }}
                            data-tooltip-id="my-tooltip"
                            data-tooltip-content="This report highlights projects that have received a funding opportunity from an investor. Operations can use it to track initial matches and follow up on next steps with both borrowers and lenders."
                            data-tooltip-place="top"
                          >
                            <i className="fas fa-info-circle" />

                          </p>

                          <Tooltip id="my-tooltip" style={{ width: '30%' }} />
                        </div>
                        <div className="mt-3 mt-lg-0 d-flex align-items-center filter">
                          <div style={{ marginRight: '5px', fontSize: '16px' }}>From Time : </div>
                          <DatePicker selected={startDate} onChange={(date) => setStartDate(date)}
                            className="custom-datepicker-input" dateFormat="yyyy-MM-dd" />
                          <div style={{ marginRight: '5px', fontSize: '16px' }}>To Time :  </div>
                          <DatePicker selected={endDate} onChange={(date) => setEndDate(date)}
                            className="custom-datepicker-input" dateFormat="yyyy-MM-dd" />
                          <select
                            className="custom-select-dropdown mx-2"
                            value={typeStatus}
                            onChange={(e) => setTypeStatus(e.target.value)}
                          >
                            <option value="" className='option'>Status</option>
                            <option value="funding_requested" className='option'>Requested</option>
                            <option value="funding_approved" className='option'>Approved</option>
                            <option value="funding_secured" className='option'>Secured</option>
                            <option value="funding_completed" className='option'>Completed</option>
                          </select>
                          <button className='export-btn ml-0 ml-lg-3 mt-3 mt-lg-0 mx-2' onClick={() => {
                            setTypeStatus('')
                            setEndDate(new Date())
                            setStartDate(new Date())
                          }} ><span>Clear</span></button>
                          <button className='export-btn ml-0 ml-lg-3 mt-3 mt-lg-0 mx-2' onClick={exportList} ><span>Export</span></button>
                        </div>
                      </div>
                    </div>
                    <div className="table-responsive">
                      <table className="table align-items-center table-flush">
                        <thead className="thead-light">
                          <tr>
                            <th>Action</th>
                            <th>Name</th>
                            <th>Funder</th>
                            <th>Project Name</th>
                            <th>Funding Requested At</th>
                            <th>Status</th>
                            <th>Investment Type</th>
                            {/* <th>Location</th> */}
                          </tr>
                        </thead>
                        <tbody>
                          {fundSecureList?.length > 0 ? (
                            fundSecureList.map((project, index) => (
                              <tr key={index}>
                                <td>
                                  <div className="d-flex flex-row align-items-center" style={{ width: "auto" }}>
                                    <Link to={`/view-project/${project?.id}`} target="_blank">
                                      <button className="viewproject-btn pull-right mb-1">
                                        <span className="text-white">View Project</span>
                                      </button>
                                    </Link>
                                    {/* <button className="viewproject-btn pull-right  ml-2 mx-2">
                                      <span className="text-white" onClick={() => {
                                        if (project?.closed_at == null && isMarked == 'transaction_cordinator') {
                                          setShow(true)
                                          setProjectId(project?.id)
                                        }
                                      }}
                                      >{project?.closed_at == null ? 'Mark as Completed' : 'Completed'}</span>
                                    </button> */}
                                  </div>
                                </td>
                                <td className="table-user">
                                  <div style={{ width: "120px" }}>
                                    <span>{project?.user?.about?.name} {project?.user?.about?.lastname}</span>
                                  </div>
                                </td>
                                <td className="table-user">
                                  <div style={{ width: "120px" }}>
                                    <span>{project?.funder?.about?.name} {project?.funder?.about?.lastname}</span>
                                  </div>
                                </td>
                                <td className="table-user">
                                  <div style={{ width: "120px" }}>
                                    <span>{project?.project_name}</span>
                                  </div>
                                </td>

                                <td className="table-user">
                                  {project?.funded_at == null ? <div style={{ width: "120px" }}><span>N/A</span>
                                  </div>
                                    :
                                    <div style={{ width: "120px" }}><span>{usTimezone(project?.funded_at)}</span></div>
                                  }
                                </td>

                                {/* <td className="table-user">
                                  {project?.capital_partner === "MultiFamily" ?
                                    <div style={{ width: "120px" }}>
                                      <span>Multi Family</span>
                                    </div> : project?.capital_partner === "SingleFamily" ?
                                      <div style={{ width: "120px" }}>
                                        <span>Single Family</span>
                                      </div> :
                                      <div style={{ width: "120px" }}>
                                        <span>{project?.capital_partner ? project?.capital_partner : ""}</span>
                                      </div>
                                  }

                                </td> */}
                                <td className="table-user">

                                  {project?.status === "funding_requested" && (
                                    <div className="project-status p-1" >
                                      <span className="text-white d-flex justify-content-center">Funding Requested</span>
                                    </div>
                                  )}

                                  {project?.status === "funding_secured" && (
                                    <div className="project-status p-1" >
                                      <span className="text-white d-flex justify-content-center">Funded Project</span>
                                    </div>
                                  )}

                                  {(project?.status === "funding_approve" || project?.status === "funding_approved") && (
                                    <div className="project-status p-1">
                                      <span className="text-white d-flex justify-content-center">Funding Approved</span>
                                    </div>
                                  )}
                                  {/* <div style={{ width: "120px" }}>
                                    <span>{project?.status}</span>
                                  </div> */}
                                </td>
                                <td className="table-user">
                                  <div style={{ width: "120px" }}>
                                    <span>{project?.funder?.about?.invest_type}</span>
                                  </div>
                                </td>

                                {/* <td className="table-user">
                                  <div>
                                    <div className="">{project?.funder?.about?.city && project?.funder?.about?.county ? `${project?.funder?.about?.city}, ${project?.funder?.about?.county}` : project?.funder?.about?.city}</div>
                                  </div>
                                </td> */}
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="10" className="text-center"><b>No records found</b></td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>

              <Row>
                <Col xs={12}>
                  <div className='paginate-css'>
                    <ReactPaginate
                      previousLabel="<"
                      nextLabel=">"
                      breakLabel="..."
                      pageCount={totalPages}
                      marginPagesDisplayed={1}
                      pageRangeDisplayed={2}
                      onPageChange={({ selected }) => setPage(selected)}
                      containerClassName="pagination"
                      activeClassName="active"
                    />
                  </div>
                </Col>
              </Row>
            </div>
          </main>
        </div>
      </div>

      <ConfirmationModal
        show={show}
        onClose={() => setShow(false)}
        onConfirm={() => MarkCompleted(projectId)}
        title="Mark As Completed"
        body="Are you sure to mark this project completed?"
      />

    </>

  )
}
export default NewMatches;